/*!
 * Copyright Optimus Ride 2018
 */

import moment, { Moment } from 'moment-timezone';

export const isCurrentRouteActive = (currentRoute: string, expectedRoute: string) => {
    currentRoute = currentRoute.endsWith('/') ? currentRoute.slice(0, -1) : currentRoute;
    return expectedRoute === currentRoute;
}

// Typescript has several typing bugs related to window.navigator. See more detailed information here:
// https://github.com/Microsoft/TypeScript/issues/21517
const unsafeNavigation: any = window.navigator;

export const isIos = () => {
    const userAgent = unsafeNavigation.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
};

export const isIpad = () => unsafeNavigation.userAgent.match(/iPad/i) != null;

export const isInStandaloneMode = () => 'standalone' in unsafeNavigation && unsafeNavigation.standalone;

export const getEnumKeyByEnumValue = (enumeration: any, value: any) => {
    let keys = Object.keys(enumeration).filter(x => enumeration[x] == value);
    return keys.length > 0 ? keys[0] : null;
}

export const scrollTo = (id: string) => {
    const el: null | HTMLElement = document.getElementById(id);

    if (el) {
        el.scrollIntoView({behavior: 'auto', block: 'start', inline: 'nearest'});
    }
};

/**
 * @param date ISO8601 timestamp
 * @param timezone ISO8601 timezone string
 */
export const toLocalDate = (date: string, timezone: string): Moment => {
    return moment.tz(date, timezone);
}

/**
 *
 * @param date ISO8601 date
 * @param time ISO8601 time
 * @param timezone ISO8601 timezone string
 */
export const toLocalDateTime = (date: string, time: string, timezone: string): Moment => {
    return moment.tz(`${date} ${time}`, timezone);
}

export const isRunwayOpArea = (operatingAreaId: number) => {
    const RUNWAY_OPERATING_AREA_ID = 6;
    return operatingAreaId === RUNWAY_OPERATING_AREA_ID;
}

export const isTheYardsOpArea = (operatingAreaId: number) => {
    const THE_YARDS_OPERATING_AREA_ID = 7;
    return operatingAreaId === THE_YARDS_OPERATING_AREA_ID;
}

export const formatBytes = (bytesi18n: string, bytes: number) => {
    if (bytes === 0) {
        return `0 ${bytesi18n}`;
    }
    const BASE_BYTES = 1024;
    const sizes = [bytesi18n, 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(BASE_BYTES));
    return `${parseFloat((bytes / Math.pow(BASE_BYTES, i)).toFixed(2))} ${sizes[i]}`;
}

export const PHONE_VALIDATOR = new RegExp(/((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/);

export const EMAIL_VALIDATOR = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const isPhone = (phone: string) => PHONE_VALIDATOR.test(phone);

export const isEmail = (email: string) => EMAIL_VALIDATOR.test(email);

export const compare = (a: string, b: string) => a.toLowerCase().trim() === b.toLowerCase().trim();
